module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAAXNSR0IArs4c6QAAAJtJREFUGBmNyzELAWEYwPEz6kgyKd/BYrAYLAaLxWLxSXwkXwFlUQajQfkISgYhOj+6uyKdu/r1vs/z/i8Icn5RFIWvtJCnF9d0C6Z/e3GVDWe6mT8IKqy50EtjQykd4otdmRVX+um7YcKWerJ0D1lyY5Ds36dFhxM7GhSZc2f4ESeDhzZH9sx4MEref56CFoc4Hv+MvpfiJpnxEzOklDvX7ZMoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tick.png
// module id = 708
// module chunks = 32